Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramListeningMediaContentFactory

  create: (socialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.InstagramListeningMediaContent(socialContent)
    return content

  canHandle: (socialContent) ->
    #TODO: ver por que no viene el type desde java!!!
    return socialContent.data.sub_type == "instagram_listening_media"
